export enum ReturnStatus {
  ReturnPlaced = "ReturnPlaced",
  ReturnApproved = "ReturnApproved",
  ReturnRejected = "ReturnRejected",
  ReturnBeingPickedUp = "ReturnBeingPickedUp",
  ReturnPickUpFailed = "ReturnPickUpFailed",
  ReturnInDeliveryToWarehouse = "ReturnInDeliveryToWarehouse",
  ReturnDeliveredToWarehouse = "ReturnDeliveredToWarehouse",
  ReturnBeingReviewed = "ReturnBeingReviewed",
  ReturnAwaitsForFullRefund = "ReturnAwaitsForFullRefund",
  ReturnAwaitsCustomerAtWarehouse = "ReturnAwaitsCustomerAtWarehouse",
  ReturnVerified = "ReturnVerified",
  ReturnReadyForDeliveryToCustomer = "ReturnReadyForDeliveryToCustomer",
  ReturnInDeliveryToCustomer = "ReturnInDeliveryToCustomer",
  ReturnFailedToCustomer = "ReturnFailedToCustomer",
  ReturnDeliveredToCustomer = "ReturnDeliveredToCustomer"
}

export const RETURN_STATUSES_LIST = [
  {
    label: "Pending",
    value: ReturnStatus.ReturnPlaced,
    backgroundColor: "#FF9900"
  },
  {
    label: "Approved",
    value: ReturnStatus.ReturnApproved,
    backgroundColor: "#16C350"
  },
  {
    label: "Rejected",
    value: ReturnStatus.ReturnRejected,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Picking up",
    value: ReturnStatus.ReturnBeingPickedUp,
    backgroundColor: "#16C350"
  },
  {
    label: "In Delivery to Warehouse",
    value: ReturnStatus.ReturnInDeliveryToWarehouse,
    backgroundColor: "#16C350"
  },
  {
    label: "Delivered to Warehouse",
    value: ReturnStatus.ReturnDeliveredToWarehouse,
    backgroundColor: "#16C350"
  },
  {
    label: "Pick up failed",
    value: ReturnStatus.ReturnPickUpFailed,
    backgroundColor: "#16C350"
  },
  {
    label: "Reviewing",
    value: ReturnStatus.ReturnBeingReviewed,
    backgroundColor: "#16C350"
  },
  {
    label: "Refunding",
    value: ReturnStatus.ReturnAwaitsForFullRefund,
    backgroundColor: "#16C350"
  },
  {
    label: "Awaits customer at warehouse",
    value: ReturnStatus.ReturnAwaitsCustomerAtWarehouse,
    backgroundColor: "#16C350"
  },
  {
    label: "Verified",
    value: ReturnStatus.ReturnVerified,
    backgroundColor: "#16C350"
  },
  {
    label: "Ready for delivery to customer",
    value: ReturnStatus.ReturnReadyForDeliveryToCustomer,
    backgroundColor: "#16C350"
  },
  {
    label: "In Delivery to customer",
    value: ReturnStatus.ReturnInDeliveryToCustomer,
    backgroundColor: "#16C350"
  },
  {
    label: "FailedToCustomer",
    value: ReturnStatus.ReturnFailedToCustomer,
    backgroundColor: "#FF0033"
  },
  {
    label: "Delivered",
    value: ReturnStatus.ReturnDeliveredToCustomer,
    backgroundColor: "#16C350"
  }
];

export const RETURN_CHANGING_STATUSES = [
  {
    label: "Pending",
    value: ReturnStatus.ReturnPlaced,
    backgroundColor: "#FF9900"
  },
  {
    label: "Approved",
    value: ReturnStatus.ReturnApproved,
    backgroundColor: "#16C350"
  },
  {
    label: "Rejected",
    value: ReturnStatus.ReturnRejected,
    backgroundColor: "#A8A8BB"
  }
];
